var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplainerAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 43,
    viewBox: "0 0 39 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88045 13.6368L19.5 5.7735L33.1195 13.6368V29.3632L19.5 37.2265L5.88045 29.3632V13.6368Z",
    fill: "#100F2E",
    stroke: "#100F2E",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23C13.45 23 12.9792 22.8042 12.5875 22.4125C12.1958 22.0208 12 21.55 12 21C12 20.45 12.1958 19.9792 12.5875 19.5875C12.9792 19.1958 13.45 19 14 19C14.55 19 15.0208 19.1958 15.4125 19.5875C15.8042 19.9792 16 20.45 16 21C16 21.55 15.8042 22.0208 15.4125 22.4125C15.0208 22.8042 14.55 23 14 23ZM14 27C12.3333 27 10.9167 26.4167 9.75 25.25C8.58333 24.0833 8 22.6667 8 21C8 19.3333 8.58333 17.9167 9.75 16.75C10.9167 15.5833 12.3333 15 14 15C15.1167 15 16.1292 15.275 17.0375 15.825C17.9458 16.375 18.6667 17.1 19.2 18H28L31 21L26.5 25.5L24.5 24L22.5 25.5L20.375 24H19.2C18.6667 24.9 17.9458 25.625 17.0375 26.175C16.1292 26.725 15.1167 27 14 27ZM14 25C14.9333 25 15.7542 24.7167 16.4625 24.15C17.1708 23.5833 17.6417 22.8667 17.875 22H21L22.45 23.025L24.5 21.5L26.275 22.875L28.15 21L27.15 20H17.875C17.6417 19.1333 17.1708 18.4167 16.4625 17.85C15.7542 17.2833 14.9333 17 14 17C12.9 17 11.9583 17.3917 11.175 18.175C10.3917 18.9583 10 19.9 10 21C10 22.1 10.3917 23.0417 11.175 23.825C11.9583 24.6083 12.9 25 14 25Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainerAccess);
export default __webpack_public_path__ + "static/media/explainer-access.02713675c7f148cc5ee96ea5cf638327.svg";
export { ForwardRef as ReactComponent };